export const IMAGE_SIZE = 64;
